import classNames from 'classnames';
import React from 'react';
import { range } from '@udemy/shared-utils';
import styles from "./slide-indicator.module.css";

/** Shared React Prop interface for `SlideIndicatorDots` and `SlideIndicatorDashes` */

/**
 * ### SlideIndicatorDots
 *
 * This slide indicator displays the number of slides with equally sized dots.
 * The active slide index is extended.  There is no timing animation.
 */
export const SlideIndicatorDots = ({
  pageCount,
  visiblePageIndex,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.wrapper, className)
  }, range(pageCount).map((_, index) => {
    const active = visiblePageIndex === index;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.dot, {
        [styles.active]: active
      }),
      key: index
    });
  }));
};

/**
 * ### SlideIndicatorDashes
 *
 * This slide indicator displays the number of slides with equally sized dashes.
 * There is also a timed animation tied to the amount of time per slide.
 */
export const SlideIndicatorDashes = ({
  className,
  pageCount,
  visiblePageIndex,
  intervalDuration = 7000,
  isPaused = false
}) => {
  const indicators = range(pageCount).map((_, index) => {
    const active = visiblePageIndex === index;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.dot, styles.full, {
        [styles.played]: index < visiblePageIndex
      }),
      key: index
    }, active && /*#__PURE__*/React.createElement("div", {
      style: {
        animationDuration: `${intervalDuration - 1000}ms`
      },
      className: classNames(styles.timer, {
        [styles.animating]: !isPaused
      })
    }));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.wrapper, styles.full, className)
  }, indicators);
};
//# sourceMappingURL=slide-indicator.react-component.js.map